import React from 'react'
import { Route, Routes } from 'react-router-dom';
import Home from '../components/Home'
import Sidebar from '../components/sidebar'
import Menu from '../components/menu';
import Profile from '../components/Profile';
import Footer from '../components/footer';
import Projects from '../components/Projects';
import Socialwelfare from '../components/socialwelfare';
import Awards from '../components/awards';
import Blog from '../components/blog';
import Digitaltwin from '../components/digitaltwin';
import Paralympics from '../components/paralympics';


const Profileroutes = () => {
  return (
    <div>
    <Routes>
    <Route path="/" element={<Home/>} />
    <Route path="/Sidebar" element={<Sidebar/>} />
      <Route path="/Menu" element={<Menu/>} />
    <Route path="/Profile" element={<Profile/>} />
    <Route path="/Footer" element={<Footer/>} />
    <Route path="/Projects" element={<Projects/>} />
    <Route path="/Socialwelfare" element={<Socialwelfare/>} />
    <Route path="/Awards" element={<Awards/>} />
    <Route path="/Blog" element={<Blog/>} />
    <Route path="/Digitaltwin" element={<Digitaltwin/>} />
    <Route path="/Paralympics" element={<Paralympics/>} />
    </Routes>
    </div>
  )
}

export default Profileroutes